export default {
  //el button按钮
  commonBtnConfirm: 'Xác nhận',
  commonBtnCancel: 'Hủy bỏ',
  commonBtnView: 'Thông tin chi tiết',
  commonBtnAdd: 'Thêm vào',
  commonBtnEdit: 'biên tập',
  commonBtnDel: 'xóa bỏ',
  commonBtnBatchDel: 'Xóa hàng loạt',
  commonBtnHint: 'Chỉ có thể chọn một dữ liệu',
  commonBtnSearch: 'đặt cược',
  commonBtnClear: 'trống rỗng',
  commonBtnSearchOpen: 'mở rộng',
  commonBtnSearchShrink: 'cất đi',
  commonBtnResetPassword: 'đặt lại mật khẩu',
  commonBtnDisabled: 'vô hiệu',
  commonBtnEnabled: 'cho phép',
  commonBtnBalanceSet: 'Cài đặt số dư',
  commonBtnPrivateAccount: 'Tài khoản thử nghiệm nội bộ',
  commonBtnOpenGame: 'Mở trò chơi',
  commonBtnPauseGame: 'Đóng trò chơi',
  commonBtnUser: 'người dùng',
  commonBtnAuthorize: 'cấu hình điểm tích lũy',
  commonBtnLoginAccount: 'Đăng nhập tài khoản',
  commonBtnWhitelist: 'danh sách IP trắng',
  commonBtnGameSetting: 'trò chơi',
  commonBtnMenuPermission: 'Không tìm thấy MENU',
  commonBtnRegisterLogin: 'đăng ký đăng nhập',
  commonBtnGameConfig: 'trò chơi',
  commonBtnRetentionConfig: '数据存留配置',
  commonBtnAddSubitem: 'thêm danh mục con',
  commonBtnDetails: 'Thông tin chi tiết',
  commonBtnBatchEdit: 'Chỉnh sửa hàng loạt',
  commonBtnUpdate: 'cập nhật ngay',
  commonBtnUnUpdate: 'Lưu nhưng tạm thời chưa cập nhật',
  commonBtnPlatformUpdate: 'Cập nhật nền tảng',
  commonBtnBatchUpdate: 'Cập nhật hàng loạt lên bản mới nhất',
  commonBtnUpdateNew: 'Cập nhập lên bản mới nhất',
  commonBtnSave: 'lưu',
  commonBtnOpen: 'bật',
  commonBtnClose: 'tắt',
  commonBtnAdd1: 'tăng mới',
  commonBtnBlack: 'Tiêu đề',
  commonBtnConfig: 'Số lượng cược tối đa',
  commonBtnManage: 'quản lý',
  commonBtnCancelBlack: 'hủy bỏ danh sách đen',
  commonBtnCancelAllBlack: 'Hủy bỏ danh sách đen hàng loạt',
  commonBtnSend: 'Gửi đi',
  commonBtnConfirmEdit: 'Xác nhận thay đổi',
  commonBtnDefaultMenu: 'Sử dụng menu mặc định',
  commonBtnSetDefaultMenu: 'Cài đặt menu mặc định',
  commonBtnSensitiveWord: 'từ  nhạy cảm',
  commonBtnSoonSend: 'Gửi ngay lập tức',
  commonBtnBack: 'rút',
  commonBtnSync: 'Làm cho đồng bộ',
  commonBtnRetry: 'Thử lại',
  commonBtnBatchState: '批量编辑状态',
  commonBtnSyncData: "一键同步",
  commonBtnQrcode: "查看二维码",
  commonBtnSecretKey: "重置密钥",
  commonBtnUnlock: "解锁",
  commonBtnOpenVerify: "开启验证",
  commonBtnCloseVerify: "关闭验证",
  commonBtnCancelBanSpeak: '取消禁言',
  commonBtnCancelAllBanSpeak: '批量取消禁言',
  commonBtnDictConfig: '字典配置',

  //text
  commonTextNormal: 'bình thường',
  commonTextDisabled: 'vô hiệu',
  commonTextTreeSelect1: 'Thu gọn tất cả',
  commonTextTreeSelect2: 'Mở rộng tất cả',
  commonTextTreeSelect3: 'Chọn tất cả',
  commonTextTreeSelect4: 'Hủy chọn tất cả',
  commonTextTotal: "Toàn bộ",
  commonTextSyncData: "Đồng bộ dữ liệu",

  //el message提示
  commonMessageBox: 'xác nhận xóa dữ liệu lựa chọn?',
  commonMessageBox2: 'Vui lòng chọn ít nhất một phần dữ liệu',
  commonMessageBox3: 'Xác nhận mở/ đóng dòng dữ liệu này?',
  commonMessageBox4: 'thao tác thành công',
  commonMessageBox5: 'Bạn có chắc chắn muốn đặt lại mật khẩu tài khoản đã chọn thành qwerty1234567890 không?',
  commonMessageBox6: 'Xác nhận cập nhật dữ liệu được chọn lên bản mới nhất?',
  commonMessageBox7: '确定将选择数据同步?',
  commonMessageBox8: '确定将选择数据重试?',
  commonMessageBox9: '确定将选择数据启用游戏?',
  commonMessageBox10: '确定将选择数据暂停游戏?',
  commonMessageBox11: '确定撤单，撤单后金额将无法撤回?',
  commonMessageBox12: '确定重置谷歌密钥？重置后原二维码和谷歌密钥不可用。',
  commonMessageBox13: '确定解锁？解锁后可正常使用。',
  commonMessageBox14: '冻结解冻数据无异常。',
  commonMessageBox15: '确定将选择数据开启/关闭?',
  commonMessageEnable: "Mở",
  commonMessageDisable: "Đóng",
  commonMessageAddSuccess: "thêm thành công",
  commonMessageUpdateSuccess: "thao tác thành công",
  commonMessageRemoveSuccess: "xóa thành công",
  commonMessageBigDataTime: "数据量较大，请耐心等待",


  commontTips: 'Nhắc nhở',
  commonTipSelect: "Vui lòng chọn",
  commonTipInput: "Vui lòng nhập",
  commonTipStartTime: "Thời gian bắt đầu",
  commonTipEndTime: "Thời gian kết thúc",
  commonTipStart: "Bắt đầu",
  commonTipEnd: "Kết thúc",

  commonTimeToday: "hôm nay",
  commonTimeYesterday: 'Hôm qua',
  commonTimeNearly3: '3 ngày gần đây',
  commonTimeNearly7: '7 ngày gần đây',
  commonTimeNearly15: '15 ngày gần đây',
  commonTimeNearly30: '30 ngày gần đây',
  commonTimeNearly60: '60 ngày gần đây',
  commonTimeNearly90: '90 ngày gần đây',

  commonUploading: "tải lên",
  commonUploadSize: "Vui lòng tải lên một hình ảnh dưới 2 triệu",
  commonUploadError: "Không tải lên được hình ảnh",

  //el placeholder
  commonPlaceholderIp: 'Vui lòng nhập đúng định dạng IP',
  commonPlaceholderRemake: 'Nhập ghi chú',
  commonPlaceholderStatus: 'Vui lòng nhập trạng thái',
  commonPlaceholderNumber: 'Vui lòng nhập 1-10 số thuần lớn hơn 0',
  commonPlaceholderPlatform: 'chọn nhà cái',
  commonPlaceholderValidate1: 'Vui lòng nhập 1-10 số thuần lớn hơn 0',
  commonPlaceholderValidate2: 'Vui lòng nhập 1-10 số thuần lớn hơn 0',
  commonPlaceholderValidate3: 'Vui lòng nhập 1-100 ký tự',
  commonPlaceholderValidate4: 'Vui lòng nhập 5-15 ký tự',
  commonPlaceholderValidate5: 'Vui lòng nhập 16-32 chữ cái hoặc số',
  commonPlaceholderValidate6: 'Vui lòng nhập 1-20 ký tự',
  commonPlaceholderValidate7: 'Vui lòng nhập 3-8 chữ cái hoặc số',
  commonPlaceholderValidate8: 'Nhập chữ số từ 0-100, tối đa 2 chữ số thập phân',
  commonPlaceholderValidate9: 'Bạn chỉ có thể nhập phân loại số nguyên',
  commonPlaceholderValidate10: 'Vui lòng nhập 32 ký tự',
  commonPlaceholderValidate11: 'Vui lòng nhập 8 ký tự',
  commonPlaceholderValidate12: 'Mật khẩu đăng nhập và mật khẩu xác nhận không được giống nhau',
  commonPlaceholderValidate13: 'Vui lòng nhập 1-8 số thuần lớn hơn 0',

  commonPlaceholderAccount: 'Vui lòng nhập tài khoản',
  commonPlaceholderPassword: 'Vui lòng nhập mật khẩu',
  commonPlaceholderTreeOperate: 'Quy trình thao tác',

  commonNav1: 'Trang cá nhân',
  commonNav2: 'Khác',
  commonNav3: 'Trang chủ',

  commonEmptyData: 'Không có dữ liệu'
}
